import { ReleaseRef, ReleaseVersion } from '../versions/types';

import { Geography } from './documentation/types';
import { FlowsType } from './V4/flows/types';

export type RecentDataset = {
  dataset: Dataset;
  viewed_at: string;
};

export type FetchDatasetParams = ReleaseRef & { dataset_id: string };

export type FetchFlowDetailsParams = FetchDatasetParams & {
  flow_id: string;
  flow_type?: FlowsType;
};

export type Dataset = {
  activity_name: string;
  geography: Geography;
  has_access: boolean;
  index: number;
  reference_product: string;
  system_model: ReleaseVersion['system_model'];
  version: ReleaseVersion['version'];
  unit: string;
  sector: string;
};

export type v4Dataset = {
  id: string;
  version: ReleaseVersion['version'];
  system_model: ReleaseVersion['system_model'];
  name: string;
  geography: string;
  geography_short: string;
  product: string;
  unit: string;
  has_access: boolean;
};

export type RelatedDataset = {
  description: string;
  is_current: boolean;
  related_dataset_type: string;
  spold_id: number;
  system_model: ReleaseVersion['system_model'];
  version: ReleaseVersion['version'];
};

export enum ExportFileType {
  PDF = 'PDF',
}

export type ExportFile = {
  name: string;
  description: string;
  type: ExportFileType;
  url: string;
  is_s3_presigned: boolean;
};

type DatasetHistoryDetail = {
  id: number;
  activity: string;
  geography: string;
  product: string;
};

type DatasetHistoryItem = {
  status_long: string;
  status_short: string;
  from_: DatasetHistoryDetail[];
  predecessor: string;
  to: DatasetHistoryDetail[];
};

export type DatasetHistory = {
  [key: string]: DatasetHistoryItem;
};
